import { render, staticRenderFns } from "./ECSynchronisationStatusIndicator.vue?vue&type=template&id=2d1d5dd3&scoped=true&"
import script from "./ECSynchronisationStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./ECSynchronisationStatusIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1d5dd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VProgressCircular,VTooltip})
